import { useEffect, useState, useCallback } from 'react';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { PortfolioCardProps } from '../types';
import { getPortfolioLoanDetails } from './portfolioCardService';

interface PortfolioCardHookProps {
  portfolioIds: number[];
}

export const usePortfolioCards = ({ portfolioIds }: PortfolioCardHookProps) => {
  const [data, setData] = useState<PortfolioCardProps[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const authenticationContext = useAuthenticationContext();

  const fetchPortfolioData = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const result = await getPortfolioLoanDetails(authenticationContext, portfolioIds);
      setData(result);
      if (result?.length === 0) setError('no_data_error');
    } catch (error) {
      setError('api_error');
      console.error('Error fetching portfolio data:', error);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [authenticationContext, portfolioIds]);

  const refetchWithDelay = useCallback(async () => {
    await new Promise((resolve) => setTimeout(resolve, 5000));

    await fetchPortfolioData();
  }, [fetchPortfolioData]);

  useEffect(() => {
    fetchPortfolioData();
  }, [fetchPortfolioData]);

  return { data, loading, error, refetch: refetchWithDelay };
};
